module.exports = __webpack_public_path__ + "img/c04_unittechbowmanchampion_Normal_ua.7f037468.webp";